import styled from 'styled-components';

import { Card as YogaCard } from '@gympass/yoga';
import { media } from '@gympass/yoga-helpers';

export const Card = styled(YogaCard)`
  border-radius: ${({ theme }) => theme.yoga.radii.small}px;
  box-shadow: ${({ theme }) => theme.yoga.elevations.medium};
  display: ${({ wrapper }) => (wrapper ? 'grid' : 'block')};
  padding: ${({ theme, padding }) => padding || theme.yoga.spacing.xxxlarge}px;
  min-width: ${({ theme }) => theme.yoga.sizes.contentWidth};

  ${({ theme, wrapper }) =>
    wrapper
      ? media.md`
        min-height: calc(100vh
          - ${theme.yoga.spacing.xxxlarge}px
          - ${theme.yoga.spacing.huge}px);
      `
      : ''};
`;
